import { c as _c } from "react/compiler-runtime";
import { Heading } from 'ui';
import { Divider } from '~/components/Divider';
import styles from '../TicketingInstruction.module.css';
import type { TodProps } from './tod.types';
const Tod = t0 => {
  const $ = _c(11);
  const {
    content
  } = t0;
  const {
    collectionPoint,
    tickets
  } = content;
  let t1;
  if ($[0] !== collectionPoint) {
    t1 = <p className={styles.ticketTitle}>{collectionPoint}</p>;
    $[0] = collectionPoint;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider variant="horizontal" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== tickets) {
    t3 = tickets.length > 0 && <><Heading className={styles.subtitle}>Tickets</Heading>{tickets.map(_temp)}</>;
    $[3] = tickets;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <ul data-test-id="ticketing-instruction-tod-tickets">{t3}</ul>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider variant="horizontal" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t4) {
    t6 = <>{t1}{t2}{t4}{t5}</>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export { Tod };
function _temp(ticket) {
  return <li key={ticket.reference}><span className={styles.ticketTitle}>{ticket.fromPlace?.placeName ?? ""} to {ticket.toPlace?.placeName ?? ""}</span>: <span>{ticket.reference}</span></li>;
}